import React from "react";
import { Box, Typography } from "@mui/material";
import Marquee from "react-fast-marquee";

    const platforms = ["AdCombo", "Adexico", "AffBay", "Ambalaya", "Awin", 
        "BlitzAds", "ClickBank", "ClickDealer", "ClickFlow", "ClickHunts",
        "CPAGetti", "CPAHouse", "Digistore", "Dr.Cash", "EverAd",
        "EverFlow", "GasMobi", "GiantMobi", "Gurumedia", "HealthTrader",
        "LeadBit", "LeadReaktor", "LeadRock", "LemonAd", "MaxBounty",
        "MaxWeb", "MoreNiche", "NutriProfits", "ProfitPay", "SellHealth",
        "ShakesPro", "SmartAdv", "TerraLeads", "TrafficLight", "WebVork",
    ];

const PlatformsBackground = () => {
  const marqueeRows = 10; // Adjust this to control how many rows of marquees

  return (
    <Box
      sx={{
        position: "fixed",
        top: 0,
        left: 0,
        width: "100vw",
        height: "100vh",
        overflow: "hidden",
        zIndex: 0,
        backgroundColor: "#FFF"
      }}
    >
      {Array.from({ length: marqueeRows }).map((_, rowIndex) => (
        <Marquee
          key={rowIndex}
          style={{
            position: "absolute",
            top: `${(rowIndex / marqueeRows) * 100}%`, // Distribute marquees vertically
            width: "100%",
          }}
          speed={1 + rowIndex} // Slight variation in speed for dynamic effect
          direction={rowIndex % 2 === 0 ? "left" : "right"} // Alternate directions
        >
          {platforms.map((platform, index) => (
            <Typography
              key={`${rowIndex}-${index}`}
              sx={{
                display: "inline-block",
                padding: 1,
                color: index % 2 === 0 ? "rgb(224, 224, 224)" : "rgb(201, 201, 201)",
                fontWeight: "bold",
                fontSize: "50px",
                whiteSpace: "nowrap",
                opacity: 0.3
              }}
            >
              {platform.toUpperCase()}
            </Typography>
          ))}
        </Marquee>
      ))}
    </Box>
  );
};

export default PlatformsBackground;